import { Col, Empty, Image, Row } from 'antd';
import styled from 'styled-components';
import { useTherapistCtx } from '../context/TherapistContext';
import { CardStyled } from '../styled/TherapistDetail.styled';
import FallbackImage from '../../../../assets/img/DefaultAvatar.jpg';

const GalleryImageWrapper = styled.div`
    aspect-ratio: 9 / 16;
    width: 100%;
    overflow: hidden;
    border-radius: 8px;

    .ant-image {
        width: 100%;
        height: 100%;
        display: block;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 8px;
        }
    }
`;

function GalleryTherapist() {
    const { isLoading, therapist } = useTherapistCtx();
    return (
        <CardStyled loading={isLoading}>
            {therapist?.galleries?.length > 0 ? (
                <Image.PreviewGroup>
                    <Row gutter={[16, 16]}>
                        {therapist?.galleries?.map((item, index) => (
                            <Col key={index} xs={8} sm={8} md={8} lg={8}>
                                <GalleryImageWrapper>
                                    <Image
                                        fallback={FallbackImage}
                                        src={item?.image}
                                        alt={`Image ${index + 1}`}
                                        width="100%"
                                        height="100%"
                                        style={{ objectFit: 'cover' }}
                                    />
                                </GalleryImageWrapper>
                            </Col>
                        ))}
                    </Row>
                </Image.PreviewGroup>
            ) : (
                <Empty />
            )}
        </CardStyled>
    );
}

export default GalleryTherapist;
